import { toast } from 'react-toastify';
import axios from './axios-client';

export const addInstafeed = async (obj , setLoading, setData, setTosModalOpen, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.post(`instafeed/add`, obj);
    setData(data?.data.feed);
    setLoading(false);
    setTosModalOpen(false);
    toast.success(data?.data.message);
  } catch (error) {
    setError(error);
    setLoading(false);
    toast.error(error.message);
  }
};

export const editInstafeed = async (feedId, obj , setLoading, setData, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.post(`instafeed/edit/${feedId}`, obj);
    setData(data?.data.updatedFeed);
    setLoading(false);
    toast.success(data?.data.message);
  } catch (error) {
    setError(error);
    setLoading(false);
    toast.error(error.message);
  }
};

export const getMyWineryInstafeed = async (wineryId , setLoading, setData, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.get(`instafeed/my-winery-instafeed/${wineryId}`);
    setData(data?.data);
    setLoading(false);
  } catch (error) {
    setError(error);
    setLoading(false);
    toast.error(error.message);
  }
};

export const deleteMyInstafeed = async (feedId, setLoading, setData = f => f, setOpenDeleteModal, setError = f => f) => {
  try {
    setLoading(true)
    const data = await axios.delete(`instafeed/delete/${feedId}`);
    // let temp = prevData;
    // temp = temp.filter(t => t._id !== data?.data.awardId)
    setData(null);
    setLoading(false);
    setOpenDeleteModal(false);
    toast.success(data?.data.message);
  } catch (error) {
    setError(error);
    setLoading(false);
    toast.error(error.message);
  }
};
